module.exports = __webpack_public_path__ + "img/v2_r5hikb.3dd84da5.png";